module.exports = "/assets/6d79c6dadbac7db336364747090b172c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/OZ.png
// module id = 2822
// module chunks = 0